// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__ZU5t5","wait":"loader_wait__yMgcW","fade-in":"loader_fade-in__G_TUe","loader":"loader_loader__mk5JL","spin":"loader_spin__Oz_HJ"};